import { FormValidations } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";
import FilesValidationRule from "features/validation/rules/FilesValidationRule";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";
import ValidationService from "features/validation/ValidationService";
import { TFunction } from "i18next";
import { getFileExtensionValidationMessage, getMultipleFilesValidationMessage } from "features/shared/helpers/translationHelper";

export const insertReactionValidaitons = (fileInputRef: React.RefObject<HTMLInputElement>, t: TFunction): FormValidations => {
  const validateDocumentTypes = (value: any) => {
    let files = fileInputRef.current?.files;
    let validationService = new ValidationService();

    if (files && files.length > 0) {
      return validationService.validateReuired(value);
    }

    return true;
  }

  return {
    reactionHtml: {
      required: true,
      type: "Pattern",
      regex: /^(.|\s){1,2000}$/,
      message: "insertReactionValidaitons.reactionHtml"
    } as PatternValidatonRule,
    files: {
      message: `${getMultipleFilesValidationMessage(t)} ${getFileExtensionValidationMessage(t)}`,
      type: "Files",
      filesCount: 5
    } as FilesValidationRule,
    documentsType:{
      type: "Function",
      message: "insertReactionValidaitons.documentsType",
      validate: validateDocumentTypes
    } as FunctionValidationRule
  };
}